import React, { Component } from 'react';
import DataTable from '../../../../components/Datatable';
import { scrollForTable } from '../../../../components/Datatable/utils';
import { COLUMNS } from './keys';
import { withTranslation } from 'react-i18next';

class DeviceTraffic extends Component {
    constructor() {
        super();
    }

    searchFunction(data, search) {
        if (!search) return data;
        return data.filter((item) =>
            item?.keys?.[0]?.toLowerCase()?.includes(search.toLowerCase()),
        );
    }

    shouldComponentUpdate(nextProps) {
        if (JSON.stringify(this.props.data) !== JSON.stringify(nextProps.data)) {
            return true;
        } else {
            return false;
        }
    }

    render() {
        const { t } = this.props;

        const sortFns = {
            device: (array) => array.sort((a, b) => a?.keys?.[0].localeCompare(b?.keys?.[0])),
            impressions: (array) => array.sort((a, b) => a.impressions - b.impressions),
            clicks: (array) => array.sort((a, b) => a.clicks - b.clicks),
            position: (array) => array.sort((a, b) => a.position - b.position),
            ctr: (array) =>
                array.sort((a, b) => a.clicks / a.impressions - b.clicks / b.impressions),
        };
        return (
            <div className="row card-row d-flex">
                <div className="col-12">
                    <div className="card rounded-main table-main overflow-hidden ">
                        <div className="card-header">
                            <div className="card-title text-dark fw-bold">
                                {t('tools.live_url.device_traffic.header')}
                            </div>
                        </div>
                        <div className="card-body">
                            <DataTable
                                nodes={this.props.data}
                                sortFns={sortFns}
                                COLUMNS={COLUMNS(t)}
                                fileName={t('tools.live_url.device_traffic.header')}
                                searchFunction={this.searchFunction}
                                additionalStyles={{
                                    Table: `
                                        --data-table-library_grid-template-columns : minmax(120px, 1fr)  minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) !important;
                                    ${scrollForTable}
                                    `,
                                    BaseCell: `  font-family: 'Raleway';
                                    font-weight: 500;
                                    font-size: 16px;
                                    line-height: 19px;
                                    padding: 16px 10px !important;
                                    color: #0D182C;
                                
                                
                                    &.underline {
                                        text-decoration: underline;
                                    }
                                    `,
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation()(DeviceTraffic);
